import axios from 'axios/dist/axios.min';

const instance = new axios.create()

instance.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest'
instance.defaults.headers.post['HTTP_X_REQUESTED_WITH'] = 'XMLHttpRequest'

export default instance
